export default __webpack_public_path__ + "media/images/furnished_apartments/section_left_img-97b2d271383202f5e2f6f1819d87e528.png";